module.exports = __webpack_public_path__ + "images/easily-track-deals.png";